// extracted by mini-css-extract-plugin
module.exports = {"main":"SideMenu_main__1Mv1w","header":"SideMenu_header__3x1On","dropdownImage":"SideMenu_dropdownImage__2xHTv","children":"SideMenu_children__1nkjB"};